/** Форматирование и мелкая логика раздела KPI. [Claude] 2026-11-02, Чат 6, №10. */

const MONTHS = [
    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
];

export const BLOCK_LABELS = { fixed: "Постоянная часть", variable: "Переменная часть", bonus: "Бонусная часть" };
export const TIME_TYPE_LABELS = { work: "Раб. время", extra: "Доп. время" };
export const GRADE_CODES = ["G1", "G2", "G3", "G4", "G5", "G6"];

export function periodLabel(period) {
    const m = /^(\d{4})-(\d{2})$/.exec(String(period || ""));
    if (!m) return String(period || "");
    return `${MONTHS[Number(m[2]) - 1]} ${m[1]}`;
}

export function currentPeriod(date = new Date()) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function shiftPeriod(period, delta) {
    const m = /^(\d{4})-(\d{2})$/.exec(String(period || ""));
    if (!m) return period;
    const total = Number(m[1]) * 12 + Number(m[2]) - 1 + delta;
    return `${Math.floor(total / 12)}-${String((total % 12) + 1).padStart(2, "0")}`;
}

const isNum = (v) => v !== null && v !== undefined && v !== "" && Number.isFinite(Number(v));

export function money(v) {
    if (!isNum(v)) return "—";
    return `${Number(v).toLocaleString("ru-RU", { maximumFractionDigits: 0 })} ₽`;
}

export function percent(v) {
    if (!isNum(v)) return "—";
    return `${Number(v).toLocaleString("ru-RU", { maximumFractionDigits: 1 })} %`;
}

export function plain(v, digits = 2) {
    if (!isNum(v)) return "—";
    return Number(v).toLocaleString("ru-RU", { maximumFractionDigits: digits });
}

export function hoursLabel(v) {
    if (!isNum(v)) return "";
    const total = Math.round(Number(v) * 60);
    return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}

/** Цвет дельты: минус — красный, плюс — зелёный. */
export function deltaClass(v) {
    if (!isNum(v) || Number(v) === 0) return "text-slate-500";
    return Number(v) < 0 ? "text-red-600" : "text-emerald-700";
}

export function emptyLine(block = "variable") {
    return {
        block, weight: block === "variable" ? 10 : null, points_plan: block === "fixed" ? 10 : null,
        points_fact: null, points_replace: null, metric_plan: 100, metric_fact: null, amount: null, plan_amount: null,
        indicator: "", result: "", comment: "", task_grade: null, overperf_confirmed: false,
    };
}

export function emptyTask() {
    return { title: "", hours: "", grade: "G1", time_type: "work", comment: "" };
}

export function emptyCard() {
    return {
        title: "Новая карта", employee_name: "", position: "", grade: "G1", salary: null, fixed_share_pct: 50,
        norm_hours: 176, fact_hours: 176, extra_manual: null, comment: "", lines: [emptyLine("fixed"), emptyLine("variable")], tasks: [],
    };
}

/** Сумма весов переменной части — должна быть 100. */
export function variableWeight(lines) {
    return (lines || []).filter((l) => l.block === "variable")
        .reduce((s, l) => s + (isNum(l.weight) ? Number(l.weight) : 0), 0);
}

export function moveItem(list, index, delta) {
    const to = index + delta;
    if (to < 0 || to >= list.length) return list;
    const copy = [...list];
    const [item] = copy.splice(index, 1);
    copy.splice(to, 0, item);
    return copy;
}
